module.exports = __webpack_public_path__ + "img/aliens.5c3c74de.png";